module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "object4",
    staticClass: "workContent"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    ref: "object1",
    staticClass: "heading"
  }, [_c('div', {
    staticClass: "category"
  }, [_c('p', [_vm._v(_vm._s(_vm.projects[_vm.pNumber].category))])]), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.projects[_vm.pNumber].title))])]), _vm._v(" "), _c('div', {
    staticClass: "description"
  }, [(_vm.english) ? _c('p', {
    ref: "object2"
  }, [_vm._v(_vm._s(_vm.projects[_vm.pNumber].enContent))]) : _c('p', {
    ref: "object2"
  }, [_vm._v(_vm._s(_vm.projects[_vm.pNumber].deContent))]), _vm._v(" "), (_vm.english) ? _c('a', {
    ref: "object3",
    attrs: {
      "href": _vm.projects[_vm.pNumber].url,
      "target": "_blank"
    }
  }, [_vm._v("View Project")]) : _c('a', {
    ref: "object3",
    attrs: {
      "href": _vm.projects[_vm.pNumber].url,
      "target": "_blank"
    }
  }, [_vm._v("Zur Seite")])]), _vm._v(" "), _c('span', {
    staticClass: "count"
  }, [_vm._v("0" + _vm._s(_vm.pNumber + 1) + "/03")])]), _vm._v(" "), _c('div', {
    staticClass: "workBG"
  }, [_c('svg', {
    attrs: {
      "width": "299px",
      "height": "90px",
      "viewBox": "0 0 299 90",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('title', [_vm._v("WORK")]), _vm._v(" "), _c('desc', [_vm._v("Work Icon")]), _vm._v(" "), _c('defs'), _vm._v(" "), _c('g', {
    attrs: {
      "id": "Work-Page",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd",
      "transform": "translate(-58.000000, -245.000000)",
      "opacity": "0.299999982"
    }
  }, [_c('path', {
    attrs: {
      "d": "M94.6,247.32 L114.76,247.32 L123.52,306.6 L123.76,306.6 L129.76,247.32 L151.36,247.32 L136.72,333 L112.24,333 L104.8,275.4 L104.56,275.4 L97.12,333 L72.64,333 L58,247.32 L79.6,247.32 L86.32,306.6 L86.56,306.6 L94.6,247.32 Z M177.16,290.16 C177.16,295.920029 177.239999,300.699981 177.4,304.5 C177.560001,308.300019 177.899997,311.319989 178.42,313.56 C178.940003,315.800011 179.699995,317.359996 180.7,318.24 C181.700005,319.120004 183.039992,319.56 184.72,319.56 C186.400008,319.56 187.739995,319.120004 188.74,318.24 C189.740005,317.359996 190.499997,315.800011 191.02,313.56 C191.540003,311.319989 191.879999,308.300019 192.04,304.5 C192.200001,300.699981 192.28,295.920029 192.28,290.16 C192.28,284.399971 192.200001,279.620019 192.04,275.82 C191.879999,272.019981 191.540003,269.000011 191.02,266.76 C190.499997,264.519989 189.740005,262.960004 188.74,262.08 C187.739995,261.199996 186.400008,260.76 184.72,260.76 C183.039992,260.76 181.700005,261.199996 180.7,262.08 C179.699995,262.960004 178.940003,264.519989 178.42,266.76 C177.899997,269.000011 177.560001,272.019981 177.4,275.82 C177.239999,279.620019 177.16,284.399971 177.16,290.16 Z M154.12,290.16 C154.12,282.15996 154.639995,275.340028 155.68,269.7 C156.720005,264.059972 158.439988,259.460018 160.84,255.9 C163.240012,252.339982 166.39998,249.740008 170.32,248.1 C174.24002,246.459992 179.039972,245.64 184.72,245.64 C190.400028,245.64 195.19998,246.459992 199.12,248.1 C203.04002,249.740008 206.199988,252.339982 208.6,255.9 C211.000012,259.460018 212.719995,264.059972 213.76,269.7 C214.800005,275.340028 215.32,282.15996 215.32,290.16 C215.32,298.16004 214.800005,304.979972 213.76,310.62 C212.719995,316.260028 211.000012,320.859982 208.6,324.42 C206.199988,327.980018 203.04002,330.519992 199.12,332.04 C195.19998,333.560008 190.400028,334.32 184.72,334.32 C179.039972,334.32 174.24002,333.560008 170.32,332.04 C166.39998,330.519992 163.240012,327.980018 160.84,324.42 C158.439988,320.859982 156.720005,316.260028 155.68,310.62 C154.639995,304.979972 154.12,298.16004 154.12,290.16 Z M245.68,283.56 L250.12,283.56 C253.320016,283.56 255.679992,282.620009 257.2,280.74 C258.720008,278.859991 259.48,276.400015 259.48,273.36 C259.48,269.759982 258.740007,267.200008 257.26,265.68 C255.779993,264.159992 253.360017,263.4 250,263.4 L245.68,263.4 L245.68,283.56 Z M223.36,247.32 L258.28,247.32 C262.520021,247.32 266.139985,247.879994 269.14,249 C272.140015,250.120006 274.579991,251.69999 276.46,253.74 C278.340009,255.78001 279.699996,258.199986 280.54,261 C281.380004,263.800014 281.8,266.839984 281.8,270.12 C281.8,275.880029 280.640012,280.519982 278.32,284.04 C275.999988,287.560018 272.280026,289.719996 267.16,290.52 L267.16,290.76 C272.520027,291.240002 276.19999,293.119984 278.2,296.4 C280.20001,299.680016 281.2,304.199971 281.2,309.96 L281.2,320.76 C281.2,321.960006 281.24,323.099995 281.32,324.18 C281.4,325.260005 281.519999,326.239996 281.68,327.12 C281.840001,328.000004 282.039999,328.679998 282.28,329.16 C282.600002,329.640002 282.919998,330.099998 283.24,330.54 C283.560002,330.980002 284.079996,331.399998 284.8,331.8 L284.8,333 L261.04,333 C260.479997,331.879994 260.060001,330.560008 259.78,329.04 C259.499999,327.519992 259.300001,326.000008 259.18,324.48 C259.059999,322.959992 258.98,321.500007 258.94,320.1 C258.9,318.699993 258.88,317.560004 258.88,316.68 L258.88,310.92 C258.88,308.519988 258.760001,306.520008 258.52,304.92 C258.279999,303.319992 257.860003,302.060005 257.26,301.14 C256.659997,300.219995 255.900005,299.580002 254.98,299.22 C254.059995,298.859998 252.920007,298.68 251.56,298.68 L245.68,298.68 L245.68,333 L223.36,333 L223.36,247.32 Z M291.4,247.32 L313.72,247.32 L313.72,280.2 L313.96,280.2 L330.52,247.32 L354.28,247.32 L332.68,284.76 L356.92,333 L331.48,333 L318.4,303.12 L313.72,310.32 L313.72,333 L291.4,333 L291.4,247.32 Z",
      "id": "WORK",
      "fill": "#F0F0F0"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "imageContainer"
  }, [_c('div', {
    staticClass: "blendContainer"
  }, [_c('div', {
    ref: "blend1",
    staticClass: "blendCon1"
  }), _vm._v(" "), _c('div', {
    ref: "blend2",
    staticClass: "blendCon2"
  }), _vm._v(" "), _c('div', {
    ref: "blend3",
    staticClass: "blendCon3"
  }), _vm._v(" "), _c('div', {
    ref: "blend4",
    staticClass: "blendCon4"
  }), _vm._v(" "), _c('div', {
    ref: "blend5",
    staticClass: "blendCon5"
  })]), _vm._v(" "), (_vm.pNumber === 0) ? _c('div', {
    staticClass: "case1"
  }) : _vm._e(), _vm._v(" "), (_vm.pNumber === 1) ? _c('div', {
    staticClass: "case2"
  }) : _vm._e(), _vm._v(" "), (_vm.pNumber === 2) ? _c('div', {
    staticClass: "case3"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "count"
  }, [_c('p', {
    class: {
      active: _vm.pNumber === 0
    }
  }, [_vm._v("01")]), _vm._v(" "), _c('p', {
    class: {
      active: _vm.pNumber === 1
    }
  }, [_vm._v("02")]), _vm._v(" "), _c('p', {
    class: {
      active: _vm.pNumber === 2
    }
  }, [_vm._v("03")])]), _vm._v(" "), _c('div', {
    staticClass: "navi"
  }, [_c('div', {
    staticClass: "prev",
    on: {
      "click": _vm.prev
    }
  }, [_c('svg', {
    attrs: {
      "width": "10px",
      "height": "9px",
      "viewBox": "0 0 10 9",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('title', [_vm._v("Arrow Left")]), _vm._v(" "), _c('desc', [_vm._v("Left Arrow Icon")]), _vm._v(" "), _c('defs'), _vm._v(" "), _c('g', {
    attrs: {
      "id": "Work-Page",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd",
      "transform": "translate(-663.000000, -505.000000)"
    }
  }, [_c('g', {
    attrs: {
      "id": "Work-Nav",
      "transform": "translate(663.000000, 502.000000)",
      "fill": "#FFFFFF",
      "fill-rule": "nonzero"
    }
  }, [_c('path', {
    attrs: {
      "d": "M9.5,6.5355625 L1.707,6.5355625 L4.389,3.8535625 C4.58425,3.6583125 4.58425,3.3416875 4.389125,3.1464375 C4.193875,2.9511875 3.877125,2.9511875 3.681875,3.1464375 L0.1465,6.6819375 C0.12325,6.7051875 0.1025,6.7308125 0.08425,6.7581875 C0.075875,6.7708125 0.07,6.7844375 0.062875,6.7975625 C0.0545,6.8130625 0.045125,6.8278125 0.038375,6.8441875 C0.031375,6.8610625 0.027375,6.8786875 0.02225,6.8961875 C0.01825,6.9100625 0.012875,6.9233125 0.01,6.9375625 C0.0035,6.9699375 0,7.0026875 0,7.0355625 C0,7.0359375 0.000125,7.0361875 0.000125,7.0365625 C0.000125,7.0689375 0.0035,7.1014375 0.009875,7.1333125 C0.012875,7.1484375 0.0185,7.1623125 0.022875,7.1769375 C0.02775,7.1935625 0.031625,7.2104375 0.03825,7.2265625 C0.0455,7.2439375 0.05525,7.2596875 0.06425,7.2760625 C0.071,7.2883125 0.07625,7.3008125 0.084125,7.3125625 C0.1025,7.3401875 0.123375,7.3659375 0.14675,7.3893125 L3.682,10.9244375 C3.87725,11.1196875 4.193875,11.1196875 4.389125,10.9245625 C4.584375,10.7293125 4.584375,10.4125625 4.389125,10.2173125 L1.707125,7.5355625 L9.5,7.5355625 C9.776125,7.5355625 10,7.3116875 10,7.0355625 C10,6.7594375 9.776125,6.5355625 9.5,6.5355625 Z",
      "id": "Arrow-Left"
    }
  })])])]), _vm._v(" "), (_vm.english) ? _c('p', [_vm._v("Prev")]) : _c('p', [_vm._v("Zurück")])]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('div', {
    staticClass: "next",
    on: {
      "click": _vm.next
    }
  }, [(_vm.english) ? _c('p', [_vm._v("Next")]) : _c('p', [_vm._v("Vor")]), _vm._v(" "), _c('svg', {
    attrs: {
      "width": "10px",
      "height": "9px",
      "viewBox": "0 0 10 9",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('title', [_vm._v("Arrow Right")]), _vm._v(" "), _c('desc', [_vm._v("Right Arrow Icon")]), _vm._v(" "), _c('defs'), _vm._v(" "), _c('g', {
    attrs: {
      "id": "Work-Page",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd",
      "transform": "translate(-753.000000, -505.000000)"
    }
  }, [_c('g', {
    attrs: {
      "id": "Work-Nav",
      "transform": "translate(663.000000, 502.000000)",
      "fill": "#FFFFFF",
      "fill-rule": "nonzero"
    }
  }, [_c('path', {
    attrs: {
      "d": "M99.5,6.5355625 L91.707,6.5355625 L94.389,3.8535625 C94.58425,3.6583125 94.58425,3.3416875 94.389125,3.1464375 C94.193875,2.9511875 93.877125,2.9511875 93.681875,3.1464375 L90.1465,6.6819375 C90.12325,6.7051875 90.1025,6.7308125 90.08425,6.7581875 C90.075875,6.7708125 90.07,6.7844375 90.062875,6.7975625 C90.0545,6.8130625 90.045125,6.8278125 90.038375,6.8441875 C90.031375,6.8610625 90.027375,6.8786875 90.02225,6.8961875 C90.01825,6.9100625 90.012875,6.9233125 90.01,6.9375625 C90.0035,6.9699375 90,7.0026875 90,7.0355625 C90,7.0359375 90.000125,7.0361875 90.000125,7.0365625 C90.000125,7.0689375 90.0035,7.1014375 90.009875,7.1333125 C90.012875,7.1484375 90.0185,7.1623125 90.022875,7.1769375 C90.02775,7.1935625 90.031625,7.2104375 90.03825,7.2265625 C90.0455,7.2439375 90.05525,7.2596875 90.06425,7.2760625 C90.071,7.2883125 90.07625,7.3008125 90.084125,7.3125625 C90.1025,7.3401875 90.123375,7.3659375 90.14675,7.3893125 L93.682,10.9244375 C93.87725,11.1196875 94.193875,11.1196875 94.389125,10.9245625 C94.584375,10.7293125 94.584375,10.4125625 94.389125,10.2173125 L91.707125,7.5355625 L99.5,7.5355625 C99.776125,7.5355625 100,7.3116875 100,7.0355625 C100,6.7594375 99.776125,6.5355625 99.5,6.5355625 Z",
      "id": "Arrow-Right",
      "transform": "translate(95.000000, 7.035445) scale(-1, 1) translate(-95.000000, -7.035445) "
    }
  })])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-68c43a59","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/work/work-component.vue
// module id = 40
// module chunks = 1